import { css } from '@emotion/react'
import { colors } from '@global/constants'

export const iconButton = css`
  padding: 0;

  .MuiSvgIcon-root {
    font-size: 20px;
    color: ${colors.brand.primary};
  }
`
